import React from 'react';

import Key from '@ast/magma/components/icon/icons/Key';

import { FieldInfoGroupField } from '@app/common/configurable-wizards';
import { FieldComponent, FieldLocator } from '@app/common/configurable-wizards/types';
import { isFieldInfoGroupField } from '@app/common/configurable-wizards/utils';

import { useUserSettingsTranslation } from '@app/widgets/contacts-and-settings/hooks/useUserSettingsTranslation';

import { ProfileAndSecurityFieldsListItem } from '../FieldsListItem';

import { PasswordFields } from '../../../types';

export const passkeyField = {
  description: null,
  id: PasswordFields.Passkey,
  isEnabled: true,
  isSubmittable: false,
  label: null,
  name: null,
  type: 'FIELDINFOGROUP',
};
export const DisplayPasskeyField: FieldComponent<FieldInfoGroupField> = () => {
  const { t } = useUserSettingsTranslation();
  return (
    <ProfileAndSecurityFieldsListItem
      icon={<Key />}
      title={t(
        'profile-and-security.display-passkey.label|Represents the label of the passkeys in the display mode',
        'Passkeys',
      )}
    />
  );
};

export const DisplayPasskeyFieldLocator: FieldLocator = ({ field }) => (
  isFieldInfoGroupField(field) && field.id === PasswordFields.Passkey
    ? DisplayPasskeyField
    : undefined
);
